<template>
  <div
    class="bg-primary container-fluid h-100 d-flex align-items-center justify-content-center"
    style="min-height: calc(100vh - 5rem)"
    data-cy="finalizacao-container"
  >
    <div class="col-md-8 col-lg-4 col-xl-4" data-cy="finalizacao-col">
      <div class="card rounded-0" data-cy="finalizacao-card">
        <div
          class="card-body p-lg-5 d-flex flex-column"
          data-cy="finalizacao-card-body"
        >
          <div class="text-center" data-cy="finalizacao-status">
            <h4
              class="text-primary font-weight-bold mb-0"
              v-if="message === '' && !loadingJuno"
              data-cy="finalizacao-msg-andamento"
            >
              Agendamento em andamento...
            </h4>
            <!-- mensagem de carregamento da juno -->
            <h4
              class="text-primary font-weight-bold mb-0"
              v-if="loadingJuno"
              data-cy="finalizacao-msg-pagamento-andamento"
            >
              Pagamento em andamento...
            </h4>
            <h4
              class="text-primary font-weight-bold mb-0"
              v-if="message === 'sucesso' && !loadingJuno"
              data-cy="finalizacao-msg-sucesso"
            >
              Agendamento efetuado com Sucesso!
              <span
                v-if="mostrarFormaPagamento"
                data-cy="finalizacao-msg-forma-pagamento"
              >
                <p data-cy="finalizacao-msg-forma-pagamento-texto">
                  O próximo passo agora é escolher a forma de pagamento de sua
                  preferência.
                </p>
              </span>
            </h4>
            <b-alert
              v-if="documentoCpf === false"
              show
              variant="warning"
              dismissible
              data-cy="finalizacao-alert-cpf"
            >
              <b>Atenção:</b> Para pagamentos com
              <i><b>cartão de crédito ou boleto</b></i> é obrigatório o
              preenchimento do CPF na conta do titular.
            </b-alert>
            <h4
              class="text-primary font-weight-bold mb-0"
              v-if="message !== '' && message !== 'sucesso'"
              data-cy="finalizacao-msg-erro"
            >
              Houve um erro ao processar seu agendamento.
            </h4>
          </div>
          <div
            class="m-5 text-center text-primary"
            v-if="message === '' || loadingJuno"
            data-cy="finalizacao-icon-andamento"
          >
            <font-awesome-icon
              spin
              size="10x"
              :icon="['fas', 'circle-notch']"
              data-cy="finalizacao-icon-spinner"
            ></font-awesome-icon>
          </div>
          <div
            class="m-5 text-center text-success"
            v-if="message === 'sucesso' && !loadingJuno"
            data-cy="finalizacao-icon-sucesso"
          >
            <font-awesome-icon
              size="10x"
              v-if="mostrarFormaPagamento"
              :icon="['fas', 'money-check-alt']"
              data-cy="finalizacao-icon-money"
            ></font-awesome-icon>
            <font-awesome-icon
              size="10x"
              v-if="!mostrarFormaPagamento"
              :icon="['far', 'check-circle']"
              data-cy="finalizacao-icon-check"
            ></font-awesome-icon>
          </div>
          <div
            class="m-5 text-center text-danger"
            v-if="message !== '' && message !== 'sucesso'"
            data-cy="finalizacao-icon-erro"
          >
            <font-awesome-icon
              size="10x"
              :icon="['far', 'times-circle']"
              data-cy="finalizacao-icon-times"
            ></font-awesome-icon>
          </div>
          <b-alert
            class="text-center"
            variant="danger"
            :show="message !== '' && message !== 'sucesso'"
            data-cy="finalizacao-alert-erro"
          >
            {{ message }}
          </b-alert>
          <router-link
            v-if="message === '' || loadingJuno"
            :to="{
              name: 'index',
              params: { organizationId: $route.params.organizationId }
            }"
            class="disabled btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center my-3"
            data-cy="finalizacao-btn-aguarde"
          >
            Aguarde
          </router-link>

          <router-link
            v-if="
              message === 'sucesso' &&
                get_organization.recebimentoTransferencia &&
                !loadingJuno &&
                this.agendamento.convenio.id === 148
            "
            :to="{
              name: 'pagamento',
              params: { organizationId: $route.params.organizationId },
              query: { marcacaoId: this.agendamento.id }
            }"
            class="btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center my-3"
            data-cy="finalizacao-btn-transferencia"
          >
            Pagamento por Transf. Bancária
          </router-link>
          <router-link
            v-if="
              message === 'sucesso' &&
                servicosPagamento.recebimentoCartaoCredito &&
                !loadingJuno &&
                this.agendamento.convenio.id === 148
            "
            :to="{
              name: 'pagamentoCartao',
              params: {
                organizationId: $route.params.organizationId,
                negociacao: this.$store.getters.negociacao
              }
            }"
            class="btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center my-3"
            data-cy="finalizacao-btn-cartao"
          >
            Pagamento por Cartão
          </router-link>

          <router-link
            v-if="
              message === 'sucesso' &&
                servicosPagamento.recebimentoBoleto &&
                !get_finalizado_integracao_juno &&
                !loadingJuno &&
                this.agendamento.convenio.id === 148
            "
            :to="{
              name: 'pagamentoBoleto',
              params: {
                organizationId: $route.params.organizationId,
                negociacao: this.$store.getters.negociacao
              }
            }"
            class="btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center my-3"
            data-cy="finalizacao-btn-boleto"
          >
            Pagamento por Boleto
          </router-link>

          <router-link
            v-if="
              message === 'sucesso' &&
                ((telemedicina === false &&
                  this.agendamento.convenio.id !== 148) ||
                  (get_organization.recebimentoCartaoCredito &&
                    get_finalizado_integracao_juno) ||
                  !mostrarFormaPagamento)
            "
            :to="{
              name: 'index',
              params: { organizationId: $route.params.organizationId }
            }"
            class="btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center my-3"
            data-cy="finalizacao-btn-ok"
          >
            Ótimo, obrigado!
          </router-link>
          <router-link
            v-if="message !== '' && message !== 'sucesso'"
            :to="back"
            class="btn btn-danger btn-lg rounded-0 d-flex justify-content-center align-items-center my-3"
            data-cy="finalizacao-btn-voltar"
          >
            Voltar e tentar novamente
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { axiosInstance as Axios } from "@/main";
export default {
  name: "finish",
  data: function() {
    return {
      loadingJuno: false
    };
  },
  computed: {
    ...mapGetters([
      "message",
      "get_organization",
      "get_agendamento",
      "get_finalizado_integracao_juno",
      "get_selected",
      "token"
    ]),
    back() {
      return {
        ...this.$store.getters.router_back,
        ...(localStorage.getItem("telemedicina")
          ? { telemedicina: localStorage.getItem("telemedicina") }
          : {})
      };
    },
    clinicaSelecionadaId() {
      return this.get_selected[2] ? this.get_selected[2].id : null;
    },
    servicosPagamento() {
      const servicosPagamentosConfigs = this.get_organization
        .servicoPagamentoConfigs;
      const config =
        servicosPagamentosConfigs && servicosPagamentosConfigs.length
          ? servicosPagamentosConfigs.find(
              config => config.clinicaId === this.clinicaSelecionadaId
            )
          : null;
      return (
        config || { recebimentoBoleto: false, recebimentoCartaoCredito: false }
      );
    },
    temUmaFormaPagamento() {
      return (
        this.get_organization.recebimentoTransferencia ||
        this.servicosPagamento.recebimentoBoleto ||
        this.servicosPagamento.recebimentoCartaoCredito
      );
    },
    mostrarFormaPagamento() {
      return this.temUmaFormaPagamento && this.agendamento.convenio.id === 148;
    },
    telemedicina() {
      const telemedicina = localStorage.getItem("telemedicina");
      if (telemedicina instanceof Boolean) {
        return telemedicina;
      } else if (telemedicina == "true") {
        return true;
      }
      return false;
    },
    documentoCpf() {
      return (
        this.$store.getters.user.tipoDocumento === "CPF" &&
        !!this.$store.getters.user.numeroDocumento &&
        !!this.$store.getters.user.numeroDocumento.trim()
      );
    },
    agendamento() {
      return this.$store.getters.get_agendamento;
    }
  },
  methods: {
    gerarLinkPagamentoCartao() {
      this.loadingJuno = true;
      const payload = {
        params: {
          organizationId: this.$route.params.organizationId
        }
      };
      this.$store
        .dispatch("abrir_aba_pagamento_juno", payload)
        .catch(error => {
          this.$bvToast.toast(error.response.data.message, {
            title: "Erro",
            variant: "danger",
            autoHideDelay: 5000,
            appendToast: true
          });
        })
        .finally(() => (this.loadingJuno = false));
    },
    async gerarLinkPagamentoBoleto() {
      this.loadingJuno = true;

      try {
        const response = await Axios.post(
          `${this.$serverHost}protected/pagamento/boleto`,
          {},
          {
            headers: {
              "X-Organizacao-ID": this.$route.params.organizationId,
              Authorization: `Bearer ${this.token}`
            },
            params: {
              marcacao_id: this.agendamento.id
            }
          }
        );

        if (response.status === 200) {
          const url = response.data;
          window.open(url, "_blank");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingJuno = false;
      }
    }
  },
  mounted() {
    this.$store.dispatch("reset_pagamento_juno");
    if (!this.get_agendamento.id) {
      const payload = {
        url: this.$serverHost,
        params: {
          organizationId: this.$route.params.organizationId
        }
      };
      this.$store.dispatch("confirm_schedule", payload);
    }
  }
};
</script>

<style></style>
